<template>
  <svg
    class="spinner-graphic"
    :class="{ 'global-centered': centered && !local, 'local-centered': centered && local }"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.4367 0.690387C3.34546 1.42097 2.40881 2.35933 1.68023 3.4519C0.951641 4.54447 0.445386 5.76985 0.190367 7.05807C-0.064651 8.34628 -0.0634387 9.67212 0.193935 10.9599C0.451309 12.2476 0.959804 13.4721 1.69039 14.5633C2.42097 15.6545 3.35933 16.5912 4.4519 17.3198C5.54447 18.0484 6.76985 18.5546 8.05807 18.8096C9.34628 19.0647 10.6721 19.0634 11.9599 18.8061C13.2476 18.5487 14.4721 18.0402 15.5633 17.3096L14.4506 15.6477C13.5777 16.2322 12.5981 16.639 11.5679 16.8449C10.5377 17.0508 9.47703 17.0517 8.44645 16.8477C7.41588 16.6437 6.43558 16.2387 5.56152 15.6558C4.68747 15.0729 3.93678 14.3236 3.35231 13.4506C2.76784 12.5777 2.36105 11.5981 2.15515 10.5679C1.94925 9.5377 1.94828 8.47703 2.15229 7.44645C2.35631 6.41588 2.76131 5.43558 3.34418 4.56152C3.92705 3.68747 4.67637 2.93678 5.54936 2.35231L4.4367 0.690387Z" />
    <animateTransform
      xmlns="http://www.w3.org/2000/svg"
      attributeName="transform"
      type="rotate"
      from="0 0 0"
      to="360 0 0"
      dur="0.5s"
      repeatCount="indefinite"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheSpinner',
  props: {
    centered: {
      type: Boolean,
      required: false,
      default: false
    },
    local: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
.spinner-graphic {
  &.global-centered {
    fill: $action-blue-base;
    width: 20px;
    height: 20px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &.local-centered {
    fill: $action-blue-base;
    width: 20px;
    height: 20px;
    position: relative;
    left: calc(50% - 10px);
  }
}
</style>
